
  import Vue from "vue";
  import TableAction from "@/components/table/TableAction.vue";
  import TableHeaderAndRows from "@/components/table/TableHeaderAndRows.vue";
  import EmailForm from "@/components/_modals/new-email.vue";
  import EmailBodyTab from "@/components/email/emailbody.vue";
  import EmalAttachmentTab from "@/components/email/emailattachment.vue";
  import {ModalPlugin} from "bootstrap-vue";
  import EVENTS from "@/constants/events";

  Vue.use(ModalPlugin);

  export default Vue.extend({
    name: "EditableTable",
    data() {
      return {
        view: "newProjectView",
        isLoadingMore: false,
        resultsPerPageOptions: [100, 200, 300, 500],
        show: false,
        currentSelectedResultsPerPage: 300, // Reactive property for UI updates
      };
    },
    methods: {
      onResetPage() {
        this.$store.dispatch("resetDashboard");
        this.$store.dispatch("getFilterResults", null);
      },
      async loadMoreData() {
        this.isLoadingMore = true;
        
        try {
          const filters = this.$store.getters.getFilter;
          await this.$store.dispatch("getNextFilterResults", filters);
        } catch (error) {
          // Error loading more data - silent fail for production
        } finally {
          this.isLoadingMore = false;
        }
      },
      async selectResultsPerPage(value) {
        // Update the reactive property for immediate UI feedback
        this.currentSelectedResultsPerPage = value;
        
        // Store in localStorage
        localStorage.setItem('dashboard-results-per-page', value.toString());
        
        // Update the store
        await this.$store.dispatch('updateResultsPerPage', value);
        
        // Reset pagination and reload data with new limit
        this.$store.commit("setPage", 1);
        
        // Emit to parent component (Filters) to update its value and trigger filter reload
        this.$root.$emit('results-per-page-changed', value);
      },
    },
    created() {
      //Import event constants and set local variable
      this.EVENT_ACTION = EVENTS;
      
      // Initialize the reactive property from localStorage (for UI display only)
      const stored = localStorage.getItem('dashboard-results-per-page');
      this.currentSelectedResultsPerPage = stored ? parseInt(stored, 10) : 300;
      
      // Don't update store here - let Dashboard component handle store initialization
      // to avoid duplicate API calls
    },
    computed: {
      totalResults() {
        return this.$store.getters.getTotal;
      },
      canLoadMore() {
        const projects = this.$store.getters.getProjects;
        const total = this.totalResults;
        const currentPage = this.$store.getters.getPage;
        
        // Show load more if there are projects and we haven't loaded all results
        return projects && projects.length > 0 && projects.length < total && currentPage > 1;
      },
      selectedResultsPerPage() {
        return this.currentSelectedResultsPerPage;
      },
    },
    components: {
      TableAction,
      TableHeaderAndRows,
      EmailForm,
      EmailBodyTab,
      EmalAttachmentTab,
    },
  });
